import React, { useState } from 'react'
import CreatableSelect from 'react-select/creatable'
import {
  ReactSelectLooopStyles,
  SelectVariant
} from 'front-end/src/components/common/select/Select'
import { notification } from 'front-end/src/components/common/notifications/Notifications'
import validators from '../../../../../shared/validations'
import { useElementsWithEmbeddedDomainQuery } from '../operations/embedDomainsSelect.codegen'

import '../../../components/common/tag/TagSelect.less'
import { Modal } from 'front-end/src/components/common/modal/Modal'
import { ButtonClean } from 'front-end/src/components'
import IconBubble from 'front-end/src/components/common/icon/IconBubble'
import Link from 'front-end/src/components/common/link/Link'
import { linkBuilder } from 'shared/linkBuilder'

interface IProps {
  domains: string[]
  onFormChange: (domains: string[]) => void
}

const EmbedDomainsSelect = (props: IProps) => {
  const { domains, onFormChange } = props
  const [show, setShow] = useState(false)
  const [topicsToCheck, setTopicsToCheck] = useState<any>([])
  const [domainToRemove, setDomainToRemove] = useState<string>('')

  const { refetch } = useElementsWithEmbeddedDomainQuery({
    skip: true
  })

  const getValues = () => {
    const tempValues: any[] = []
    domains.forEach((domain) => {
      tempValues.push({
        label: domain,
        value: domain
      })
    })
    return tempValues
  }

  const handleCreate = (domain) => {
    if (!domain.match(validators.domain)) {
      return notification.error(`Invalid domain: ${domain}`)
    }

    const tempValues = Array.from(domains)
    tempValues.push(domain)
    onFormChange(tempValues)
  }

  const handleChange = async (domains, action) => {
    const { data } = await refetch({ domain: action.removedValue.value })

    if (data.admin?.organisation?.elementsWithEmbeddedDomain.length !== 0) {
      setTopicsToCheck(data.admin?.organisation?.elementsWithEmbeddedDomain)
      setDomainToRemove(action.removedValue.value)
      return setShow(true)
    }

    if (!domains) {
      return onFormChange([])
    }
    const tempValues = domains.map(({ value }) => value)
    onFormChange(tempValues)
  }

  return (
    <>
      <CreatableSelect
        className="TagSelect"
        classNamePrefix="TagSelect"
        isClearable={false}
        placeholder=""
        isMulti
        onChange={handleChange}
        onCreateOption={handleCreate}
        value={getValues()}
        styles={ReactSelectLooopStyles(SelectVariant.GREY)}
      />
      <Modal
        newDesign
        className={'ModalDisableIframe'}
        header={'Remove domain'}
        show={show}
        controls={[
          <ButtonClean onClick={() => setShow(false)} key={1}>
            Close
          </ButtonClean>
        ]}
      >
        <div className={'Modal__relatedItems'}>
          <div className={'Modal__relatedItems__column'}>
            <IconBubble size="medium" />
          </div>
          <div className={'Modal__relatedItems__column'}>
            <p>
              Please remove iframes from these resources in order to remove the{' '}
              <b>{domainToRemove}</b> domain from the allowlist.
            </p>
            <ul>
              {topicsToCheck.map((topic, i) => {
                return (
                  <li key={i}>
                    <Link href={`${linkBuilder.topicEditUrl(topic.topicId)}`}>
                      <span className={'Modal__relatedItems__importantInfo'}>
                        <strong>{topic.title}</strong>{' '}
                      </span>
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default EmbedDomainsSelect
